<template>
  <Badge v-if="value" :theme="theme">{{ $tc('taskType' + value.toTitleCase()) }}</Badge>
</template>

<script>
import Badge from '@/components/Badge'

export default {
  props: {
    value: String,
  },
  computed: {
    theme() {
      switch (this.value) {
        case 'default':
          return 'secondary'
        case 'complaint':
          return 'error'
      }
    },
  },
  components: {
    Badge,
  },
}
</script>

<style lang="scss"></style>
